export enum OrganizationStatus {
  NOT_PUBLISHED = 0,
  PUBLISHED = 1,
}
